import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';
import dayjs from 'dayjs';
import React from 'react';
import { useSelector } from 'dva';

const HandleTabel = () => {
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['conditionDetail/getHandleList'];
  const data = useSelector((state) => state.conditionDetail.getHandleList);
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
    },
    {
      title: '操作人员',
      dataIndex: 'operator',
      key: 'operator',
      width: 200,
    },
    {
      title: '操作时间',
      dataIndex: 'operationTime',
      key: 'operationTime',
      width: 200,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '操作前',
      dataIndex: 'operationBefore',
      key: 'operationBefore',
      width: 300,
    },
    {
      title: '操作后',
      dataIndex: 'operationAfter',
      key: 'operationAfter',
      width: 300,
    },
  ];

  return (
    <DataTable
      border={true}
      className="demo-test"
      style={{ minWidth: '1547px', border: '1px solid #edf0f0' }}
      columns={columns}
      rowSelection={false}
      scroll={{ y: 'calc(100vh - 160px - 3rem)' }}
      dataSource={data}
      loading={loading}
    />
  );
};
export default HandleTabel;
